"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ConditionallyDisabledCell_1 = require("./ConditionallyDisabledCell");
var DestinationItem_1 = require("../DestinationItem");
var Icons_1 = require("../Icons");
var Localize_1 = require("./../../gen-src/Localize");
var PersonalSpaceCellComponent_1 = require("./PersonalSpaceCellComponent");
var ProjectCellComponent_1 = require("./ProjectCellComponent");
exports.ContainerStyle = {
    overflow: 'hidden',
    textOverflow: 'ellipsis'
};
/**
 * Wraps the Nested Project Explorer cell in a ConditionallyDisabledCell, which grays out
 * projects that are not valid destinations for the source item.
 */
function getDestinationProjectCellFormatter() {
    function buildCellMetadata(rowData) {
        var title = messageForDestinationStatus(rowData);
        if (rowData.itemType === DestinationItem_1.DestinationItemType.personalSpace) {
            return {
                text: Localize_1.Messages.PersonalSpaceName(),
                title: title,
                itemType: rowData.itemType,
                rightTag: Localize_1.Messages.PrivateToMeTag(),
            };
        }
        else if (rowData.itemType === DestinationItem_1.DestinationItemType.projectsRoot) {
            return {
                text: Localize_1.Messages.ProjectsHeader(),
                title: title,
                itemType: rowData.itemType,
            };
        }
        else {
            return {
                text: rowData.name,
                title: title,
                iconDataUri: Icons_1.Icons.ProjectContentTypeSmall,
                itemType: rowData.itemType,
            };
        }
    }
    function messageForDestinationStatus(itemInfo) {
        var messageParams = { PROJECT_NAME: itemInfo.name };
        if (itemInfo.status === 'structurally_invalid') {
            return Localize_1.Messages.invalidContentDestination(messageParams);
        }
        else if (itemInfo.status === 'insufficient_permissions') {
            return Localize_1.Messages.insufficientPermissionToMoveTo(messageParams);
        }
        return Localize_1.Messages.validProject(messageParams);
    }
    return ConditionallyDisabledCell_1.ConditionallyDisabledCellComponent(NestedProjectExplorerCellComponent(buildCellMetadata), function (rowData) { return rowData.status !== 'valid'; });
}
exports.getDestinationProjectCellFormatter = getDestinationProjectCellFormatter;
function NestedProjectExplorerCellComponent(metadataFn, testId) {
    return function TextCell(props) {
        var data = metadataFn(props.row.data);
        if (data.itemType === DestinationItem_1.DestinationItemType.personalSpace) {
            return React.createElement(PersonalSpaceCellComponent_1.PersonalSpaceCellComponent, __assign({}, data, { testId: testId }));
        }
        else {
            return React.createElement(ProjectCellComponent_1.ProjectCellComponent, __assign({}, data, { testId: testId }));
        }
    };
}
//# sourceMappingURL=NestedProjectExplorerCell.js.map